import { combineReducers } from "redux";
import constants from "modules/campaign/constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  listSearchCampaignResult: createApiReducer(constants.LIST_SEARCH_CAMPAIGN, []),
  listTopKeywordResult: createApiReducer(constants.LIST_TOP_KEYWORD, []),
  listDisplayCampaignResult: createApiReducer(constants.LIST_DISPLAY_CAMPAIGN, []),
  listTopAudienceResult: createApiReducer(constants.LIST_TOP_AUDIENCE, []),
  listTopPlacementResult: createApiReducer(constants.LIST_TOP_PLACEMENT, []),
});

export default reducers;
